import React from 'react';
import c from 'classnames';

import { useThemeVariable } from '@lyearn/style';

import { LoaderProps } from './types';

const Loader: React.FC<React.PropsWithChildren<LoaderProps>> = (props) => {
  const {
    arcColorToken = 'icon-active',
    circleColorToken = 'icon-placeholder',
    className,
    size = 18,
    thickness = 3,
  } = props;

  const arcColor = useThemeVariable(arcColorToken);
  const circleColor = useThemeVariable(circleColorToken);

  return (
    <svg
      className={c(className, 'animate-spin')}
      fill="none"
      height={size}
      viewBox="0 0 24 24"
      width={size}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.5 12.1C21.5 17.4148 17.2339 21.7 12 21.7C6.76606 21.7 2.5 17.4148 2.5 12.1C2.5 6.78529 6.76606 2.50005 12 2.50005C17.2339 2.50005 21.5 6.78529 21.5 12.1Z"
        stroke={circleColor}
        strokeWidth={thickness}
      />
      <path
        d="M21.5 12C21.5 6.4772 17.374 2.50005 11.9009 2.50005"
        stroke={arcColor}
        strokeLinecap="round"
        strokeWidth={thickness}
      />
    </svg>
  );
};

export default React.memo(Loader);
